const DEFAULT_NEW_USER_FREE_DAYS = 7;
const MAX_NEW_USER_FREE_DAYS = 15;
const DAY_BY_COMPLETED_ONBOARDING_TASK = 2;

export { DEFAULT_NEW_USER_FREE_DAYS, MAX_NEW_USER_FREE_DAYS, DAY_BY_COMPLETED_ONBOARDING_TASK }